import {
    PERSON_RECEIVE,
    PERSON_ERROR,
    PERSON_CHANGE_MODE,
    ADDRESS_RECEIVE,
    ADDRESS_ERROR,
    ADDRESS_CHANGE_MODE,
    ORDER_RECEIVE,
    ORDER_ERROR,
    ORDER_CHANGE_MODE,
    ORDER_CHANGE_CURRENTPAGE,
    ORDER_SET_ORDER,
    ACCOUNT_ORDERS_RECEIVE,
    ACCOUNT_ORDERS_ERROR,
    ACCOUNT_ORDERS_LOADING,
    ACCOUNT_ORDERS_RESET,
    ACCOUNT_ORDERS_SET_ORDER,
    ACCOUNT_ORDERS_CHANGE_MODE,
    ACCOUNT_ORDERS_RECEIVE_LINES,
    ACCOUNT_ORDERS_LINES_LOADING,
    ViewMode,
} from '../constants';
import { person as personReducer } from './Person.reducer';
import { address as addressReducer } from './Address.reducer';
import { order as orderReducer } from './Order.reducer';
import { accountOrders as accountOrdersReducer } from './AccountOrders.reducer';

const defaultState = {
    persons: {},
    addresses: {},
    orders: {
        currentPage: 1,
    },
    accountOrders: {
        list: [],
        loading: false,
        loaded: false,
        hasMore: false,
        errors: {},
        mode: ViewMode.List,
        selectedOrder: null,
    },
};

export const myPage = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case PERSON_RECEIVE:
        case PERSON_ERROR:
        case PERSON_CHANGE_MODE:
            return {
                ...state,
                persons: personReducer(state.persons, action),
            };
        case ADDRESS_RECEIVE:
        case ADDRESS_ERROR:
        case ADDRESS_CHANGE_MODE:
            return {
                ...state,
                addresses: addressReducer(state.addresses, action),
            };
        case ORDER_RECEIVE:
        case ORDER_ERROR:
        case ORDER_CHANGE_MODE:
        case ORDER_CHANGE_CURRENTPAGE:
        case ORDER_SET_ORDER:
            return {
                ...state,
                orders: orderReducer(state.orders, action),
            };
        case ACCOUNT_ORDERS_RECEIVE:
        case ACCOUNT_ORDERS_ERROR:
        case ACCOUNT_ORDERS_LOADING:
        case ACCOUNT_ORDERS_RESET:
        case ACCOUNT_ORDERS_SET_ORDER:
        case ACCOUNT_ORDERS_CHANGE_MODE:
        case ACCOUNT_ORDERS_RECEIVE_LINES:
        case ACCOUNT_ORDERS_LINES_LOADING:
            return {
                ...state,
                accountOrders: accountOrdersReducer(state.accountOrders, action),
            };
        default:
            return state;
    }
};
